<!--sidebar-->
<c-sidebar
  #sidebar1="cSidebar"
  class="d-print-none sidebar sidebar-fixed bg-dark-gradient border-end"
  colorScheme="dark"
  id="sidebar1"
  visible
>
  <c-sidebar-header class="border-bottom">
    <c-sidebar-brand
      cSidebarToggle="sidebar1"
      toggle="unfoldable"
      style="cursor: pointer"
    >
      <img
        class="sidebar-brand-full"
        src="assets/images/DataRev_COLOR_PNGTEXTW.png"
        alt="Datarev Logo"
        height="28"
      />
      <!-- Logo reducido -->
      <img
        class="sidebar-brand-narrow"
        src="assets/main-image-collapsed.png"
        alt="Datarev Logo"
        height="32"
      />
    </c-sidebar-brand>
    <button
      cSidebarToggle="sidebar1"
      cButtonClose
      class="d-lg-none"
      dark
      toggle="visible"
    ></button>
    <button cSidebarToggler="sidebar1" toggle="unfoldable"></button>
  </c-sidebar-header>

  <ng-scrollbar
    #scrollbar="ngScrollbar"
    (updated)="onScrollbarUpdate(scrollbar.state)"
    class="overflow"
    pointerEventsMethod="scrollbar"
    visibility="hover"
  >
    <c-sidebar-nav
      #overflow
      [navItems]="navItems"
      dropdownMode="close"
      compact
    />
  </ng-scrollbar>
</c-sidebar>

<!--main-->
<div class="wrapper d-flex flex-column min-vh-100">
  <!--app-header-->
  <app-default-header
    [cShadowOnScroll]="'sm'"
    class="mb-4 d-print-none header header-sticky p-0 shadow-sm"
    position="sticky"
    sidebarId="sidebar1"
  />
  <!--app-body-->
  <div class="body flex-grow-1">
    <c-container breakpoint="lg" class="h-auto px-4">
      <app-default-breadcrumb />
      <router-outlet />
    </c-container>
  </div>
  <!--app footer-->
  <app-default-footer />
</div>

<!--aside-->
<app-default-aside style="display: none" />
